import { getFileReader } from 'utils/wrappers';
import { showError } from 'utils/messages';
import { truncate } from 'utils/strings';

import Base from 'app/views/base';

import tmpl from 'templates/image_upload';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'change input.read-image': 'readImage',
  },

  initialize(options) {
    this.modelProperty = options.modelProperty;
    this.minWidth = options.minWidth;
    this.listenTo(this.model, 'change', this.render);
    this.filename = undefined;
  },

  context() {
    return {
      image: this.model.escape(this.modelProperty),
      filename: truncate(this.filename, 55),
    };
  },

  readImage(e) {
    const input = e.target;
    if (!window.FileReader || !input.files || !input.files[0]) {
      showError('Sorry, your browser doesn\'t support file uploads (FileReader API).');
      return;
    }

    const file = input.files[0];
    this.readFile(file, (image, result) => {
      if (!this.verifyWidth(image.width)) {
        showError(`Image width must be at least ${this.minWidth}px.`);
        return;
      }

      this.model.set(this.modelProperty, result);
    });
  },

  readFile (file, cb) {
    const reader = getFileReader();
    reader.onload = this.getImageFromReader(file.name, reader, cb);
    reader.readAsDataURL(file);
  },

  getImageFromReader(fileName, reader, cb) {
    return (e) => {
      this.filename = fileName;
      const image = new window.Image();
      image.src = e.target.result;
      image.onload = () => {
        cb(image, reader.result);
      };
    };
  },

  verifyWidth(imageWidth) {
    return this.minWidth ? Boolean(imageWidth >= this.minWidth) : true;
  },
});



// WEBPACK FOOTER //
// ./app/views/image_upload_view.js